/**
 * Confirmation Dialog Component for Email Ad Validation
 */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import { emailAdValidationStyles } from '../styles';

const styles = emailAdValidationStyles;

const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  loading = false,
  variant = 'delete', // 'delete', 'warning', 'info'
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'delete':
        return {
          icon: <DeleteIcon style={{ color: '#d32f2f', fontSize: '24px' }} />,
          confirmButtonColor: '#d32f2f',
        };
      case 'warning':
        return {
          icon: null,
          confirmButtonColor: '#ed6c02',
        };
      default:
        return {
          icon: null,
          confirmButtonColor: '#1976d2',
        };
    }
  };

  const variantStyles = getVariantStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: '8px',
          padding: '8px',
        },
      }}
    >
      <DialogTitle>
        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            {variantStyles.icon}
            <Typography variant="h6" style={{ fontWeight: 600 }}>
              {title}
            </Typography>
          </Box>
          <IconButton onClick={onClose} size="small" style={{ color: '#666' }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" style={{ color: '#555', lineHeight: 1.6 }}>
          {message}
        </Typography>
      </DialogContent>

      <DialogActions style={{ padding: '16px 24px 24px' }}>
        <Button
          onClick={onClose}
          variant="outlined"
          style={{
            borderColor: '#ddd',
            color: '#666',
            textTransform: 'none',
            minWidth: '80px',
          }}
          disabled={loading}
        >
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          style={{
            backgroundColor: variantStyles.confirmButtonColor,
            color: 'white',
            textTransform: 'none',
            minWidth: '80px',
            marginLeft: '12px',
          }}
          disabled={loading}
        >
          {loading ? 'Processing...' : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  loading: PropTypes.bool,
  variant: PropTypes.oneOf(['delete', 'warning', 'info']),
};

export default ConfirmationDialog;
